/* src/modules/profile/action_types.js */

export const changePasswordTypes = [
  'CHANGE_PASSWORD',
  'CHANGE_PASSWORD_SUCCESS',
  'CHANGE_PASSWORD_FAIL',
];

export const modifyUserTypes = [
  'MODIFY_USER',
  'MODIFY_USER_SUCCESS',
  'MODIFY_USER_FAIL',
];

export const updateAdminNotificationPreferenceTypes = [
  'UPDATE_ADMIN_NOTIF_PREF',
  'UPDATE_ADMIN_NOTIF_PREF_SUCCESS',
  'UPDATE_ADMIN_NOTIF_PREF_FAIL',
];



// WEBPACK FOOTER //
// ./src/modules/profile/action_types.js